import React, { useState } from 'react';

import { useMatch } from 'react-router-dom';
import styled from 'styled-components';

import { routes } from 'utils/routing';

import { OffersUIProvider } from './offers-ui-context';
import { OffersRouter } from './routes';

interface IContainer {
  detailsPanelContentHeight: number;
}
const Container = styled.div<IContainer>`
  width: 100%;
  min-height: 50vh;
  ${Styles.desktop`
    display: flex;
    flex-direction: row;
    height: ${(p: IContainer) => `max(${p.detailsPanelContentHeight}px, 100vh)`};
  `}
`;

interface IUIRefreshOffersViewProps {
  className?: string;
  suffixUrl: string;
  currentUrl: string;
  hideHeaderBar?: boolean;
  urlOfferId: string | null;
}

const UIRefreshOffersView: React.FC<IUIRefreshOffersViewProps> = ({
  className,
  suffixUrl,
  hideHeaderBar,
  currentUrl,
  urlOfferId,
}) => {
  const [detailsPanelContentHeight, setDetailsPanelContentHeight] = useState(0);

  return (
    <OffersUIProvider
      suffixUrl={suffixUrl}
      currentUrl={currentUrl}
      hideHeaderBar={hideHeaderBar}
      urlOfferId={urlOfferId}
      updateDetailsPanelContentHeight={setDetailsPanelContentHeight}
    >
      <Container className={className} detailsPanelContentHeight={detailsPanelContentHeight}>
        <OffersRouter />
      </Container>
    </OffersUIProvider>
  );
};

/**
 * This component grabs the `offerId` from the URL and passes it to the main Offers view.
 * The url is the source of truth for which offer is selected/previewed. This plays a critical role
 * in navigation, sub-routing, and shareability of offers!
 */
export interface IUIRefreshOffersProps
  extends Pick<IUIRefreshOffersViewProps, 'className' | 'hideHeaderBar'> {
  suffixUrl?: string;
  currentUrl?: string;
}

export const UIRefreshOffers: React.FC<IUIRefreshOffersProps> = ({
  className,
  suffixUrl = '/',
  currentUrl = routes.offers,
  hideHeaderBar,
}) => {
  const match = useMatch(`${currentUrl}${suffixUrl}/*`);
  const offerIdSlug = match?.params['*']!;

  return (
    <UIRefreshOffersView
      className={className}
      urlOfferId={offerIdSlug}
      suffixUrl={suffixUrl}
      currentUrl={currentUrl}
      hideHeaderBar={hideHeaderBar}
    />
  );
};
